import Actions from 'redux/actions'
import type { CallAPIAction, Status } from 'api/types'
import { SendLaborerReportFailResponse, SendLaborerReportResponse } from 'api/contractAuthAPI'

type State = {
  errorMessage?: string
} & Status

const initialState = {
  isLoading: false,
  success: false,
  fail: false,
  errorMessage: '',
}

export default (
  state: State = initialState,
  action: CallAPIAction<
    Actions.SEND_LABORER_REPORT_ASYNC,
    Actions.SEND_LABORER_REPORT_SUCCESS,
    Actions.SEND_LABORER_REPORT_FAIL,
    SendLaborerReportResponse,
    SendLaborerReportFailResponse
  >,
): State => {
  switch (action.type) {
    case Actions.SEND_LABORER_REPORT_ASYNC:
    case Actions.SEND_LABORER_REPORT_SUCCESS: {
      return {
        ...state,
        ...action.status,
      }
    }
    case Actions.SEND_LABORER_REPORT_FAIL: {
      return {
        ...state,
        ...action.status,
        errorMessage: action.payload?.message,
      }
    }
    default:
      return state
  }
}
